define('modules/templates/views/template_item',['require','exports','module','base/itemview','env','ldsh!../templates/templates_item'],function(require, exports, module){
  "use strict";
  var ItemView = require("base/itemview"),
      config = require("env");

  module.exports = ItemView.extend({
    tagName: "div",
    className: "ed-template-box",
    template: require("ldsh!../templates/templates_item"),

    triggers: {
      "click .js-select": "template:select",
      "click .js-image": "template:preview"
    },

    helpers: function(){
      var data = this.model.toJSON();
      return {
        name: data.name,
        description: data.meta ? data.meta.description : "",
        previewUrl: this._generateImageUrl()
      };
    },

    _generateImageUrl: function(){
      if(this.model.get("previewUrl")){
        return config.apiHost.replace("https:", "") + "/img/assets/" + this.model.get("previewUrl") + "?" + Math.random()*10;
      }
      else {
        return "/app/img/prev-template.png";
      }
    },

    onRender: function(){
      this.$el.i18n();
    }
  });
});

